import deliveryOptionTypes from './../../../ukrail/delivery-options-types';
import {railStates} from '../../../ukrail/ukrail-routes';
import {flightStates} from '../../../flights/flights-routes';
import {outOfPolicyStatusStyle} from '../../../common/enum/out-of-policy-status-style';

const DEFAULT_SEAT_RESERVATION_AND_PREFERENCES = true;

export default function UkRailResultBaseController( // eslint-disable-line
    $scope,
    $state,
    $rootScope,
    $filter,
    $stateParams,
    $sce,
    railsFactory,
    basketService,
    userService,
    l10nService,
    baseEvents,
    railsUtils,
    timeService,
    railsService,
    railAmendmentService,
    moment,
) {
    'ngInject';

    init();

    function init() {
        getRailCards();
    }

            const regionalSettings = userService.getRegionalSettings();
            $scope.isAmendmentMode = railAmendmentService.isAmendmentMode();
            $scope.module = railsFactory.getModule();
            $scope.isUkRail = railsFactory.isUkRail();
            $scope.labels = railsFactory.getLabels();
            $scope.options = railsFactory.options;
            $scope.params = railsFactory.params;
            $scope.tempParams = angular.copy(railsFactory.params);
            $scope.showFiltersFlight = true;
            $scope.deliveryOptionTypes = deliveryOptionTypes;
            $scope.form = {};
            $scope.disableTravelCard = false;

            $scope.$state = $state;
            $scope.user = userService.getUser();
            let convertedReturnDate = timeService.getDateInUserRegionFormatOrCurrentDate($scope.params.RailTicketSearchSegments[0]._date);

            $scope.$watch(() => {
                return $scope.params
                    && $scope.params.TicketByPostAddressType
                    && $scope.params.TicketByPostAddressType.Description;
            }, () => $scope.addressErrorVisible = false);

            function bindDates(outwardDate, returnDate) {
                let convertedDepartureDate = null;

                if (outwardDate) {
                    convertedDepartureDate = timeService.getDateInUserRegionFormatOrCurrentDate(outwardDate).format(regionalSettings.fullDayMonDateYearFormat);
                }
                if (returnDate) {
                    convertedReturnDate = timeService.getDateInUserRegionFormatOrCurrentDate(returnDate).format(regionalSettings.fullDayMonDateYearFormat);
                }

                if (railsUtils.isRoundTripOrMultiTripFlight($scope.params.flightType)) {
                    $scope.isRoundTrip = !$scope.params.isOpenReturn;
                    convertedReturnDate
                        = timeService.getDateInUserRegionFormat(returnDate)
                            .format(regionalSettings.fullDayMonDateYearFormat);
                }

                Object.assign($scope, {
                    convertedDepartureDate,
                    convertedReturnDate,
                });
            }

            const [searchSegment] = $scope.params.RailTicketSearchSegments;
            if (!searchSegment._departure || !searchSegment._arrival) {
                return $state.go('^');
            }

            $scope.Origin = searchSegment._departure.DisplayString;
            $scope.Destination = searchSegment._arrival.DisplayString;

            $scope.rails = railsFactory.getFlights();

            if (_.isEmpty($scope.rails)) {
                return $state.go(railStates.ROUNDTRIP);
            }

            $scope.ErroMessage = '';
            if ($scope.rails.ErrorReport.ResponseError) {
                [$scope.ErroMessage] = $scope.rails.ErrorReport.ResponseError;
                return;
            }

            function getRailCards() {
                railsFactory.getStaticData()
                    .then(({data: {RailCards}}) => $scope.railCards = RailCards);
            }

            bindJourneyDetails();

            function bindJourneyDetails() {
                $scope.outwardsJourneyDetails = [];
                $scope.returnJourneyDetails = [];
                $scope.outwardJourneyAvailableTrains = 0;

                for (const journeyCount in $scope.rails.TicketsGroupedByJourneyId) {
                    if (!$scope.rails.TicketsGroupedByJourneyId[journeyCount].JourneyDetail.Direction) {
                        $scope.outwardsJourneyDetails.push($scope.rails.TicketsGroupedByJourneyId[journeyCount]);
                        $scope.outwardJourneyAvailableTrains += 1;

                    } else {
                        $scope.returnJourneyDetails.push($scope.rails.TicketsGroupedByJourneyId[journeyCount]);
                    }
                }
                $scope.noOfOutwardJourney = $scope.outwardsJourneyDetails.length;
                $scope.noOfReturnJourney = $scope.returnJourneyDetails.length;

                let outwardDate = null;
                let returnDate = null;
                if ($scope.noOfOutwardJourney > 0) {
                    outwardDate = moment($scope.outwardsJourneyDetails[0].JourneyDetail.DepartureDate.split('T')[0], 'YYYY-MM-DD');
                }
                if ($scope.noOfReturnJourney > 0) {
                    returnDate = moment($scope.returnJourneyDetails[0].JourneyDetail.DepartureDate.split('T')[0], 'YYYY-MM-DD');
                }
                bindDates(outwardDate, returnDate);

                $scope.outwardsJourneyDetails = addDummyJourneyTicketDetails($scope.outwardsJourneyDetails);
                $scope.returnJourneyDetails = addDummyJourneyTicketDetails($scope.returnJourneyDetails);
            }

            function addDummyJourneyTicketDetails(cheapestTicket) {
                const cheapestTicketCount = cheapestTicket.length;
                if (cheapestTicketCount < 4) {
                    for (let i = 0; i < 4 - cheapestTicketCount; i++) {
                        const dummyCheapestTicket = {
                            CheapestSingle: null,
                            CheapestFirstSingle: null,
                            JourneyDetail: {
                                OriginName: '-',
                                OriginCode: '-',
                                DepartureDate: '-',
                                DestinationName: '-',
                                DestCode: '-',
                                ArrivalDate: '-',
                                Id: Math.random(),
                            },
                        };
                        cheapestTicket.splice(0, 0, dummyCheapestTicket);
                    }
                }
                return cheapestTicket;
            }

            $scope.toggleSingleClassTickets = function() {
                $scope.singleClassTicketsShown = !$scope.singleClassTicketsShown;
                return $scope.singleClassTicketsShown;
            };

            $scope.toggleFirstClassTickets = function() {
                $scope.firstClassTicketsShown = !$scope.firstClassTicketsShown;
                return $scope.firstClassTicketsShown;
            };

            function addDummyTicketDetails(ticketArray) {
                const ticketArrayCount = ticketArray.length;
                const emptyTicketForJourney = {
                    Id: 0,
                    Total: 0,
                    Name: 'Name',
                    Description: 'Description',
                };
                if (ticketArrayCount < 4) {
                    for (let tmpTicketCount = 0; tmpTicketCount < 4 - ticketArrayCount; tmpTicketCount++) {
                        ticketArray.splice(0, 0, emptyTicketForJourney);
                    }
                }
                return ticketArray;
            }
            bindTickets(2);

            function bindTickets() { // eslint-disable-line

                $scope.singleClassTicketGroupbyName = [];
                $scope.returnClassTicketGroupbyName = [];
                $scope.firstClassTicketGroupbyName = [];

                $scope.ticketGroupbyName = [];

                //Single Class Ticket
                for (const ticketFareCount in $scope.rails.SingleClassRailTickets) {
                    if ($scope.rails.SingleClassRailTickets.hasOwnProperty(ticketFareCount)) {
                    $scope.ticketName = '';
                    $scope.ticketType = '';
                    $scope.ticketDescription = '';
                    $scope.RteRestrict = '';
                    $scope.ticketFare = $scope.rails.SingleClassRailTickets[ticketFareCount].Fare;
                    $scope.RteRestrict = $scope.rails.SingleClassRailTickets[ticketFareCount].RouteRestriction;
                    let onwardsTicketsGroupedByTicketFare = [];
                    let returnTicketsGroupedByTicketFare = [];
                    for (let i = 0; i < $scope.rails.SingleClassRailTickets[ticketFareCount].Tickets.length; i++) {
                        if ($scope.ticketName === null || $scope.ticketName === '') {
                            $scope.ticketName = $scope.rails.SingleClassRailTickets[ticketFareCount].Tickets[i].Name;
                            $scope.ticketType = $scope.rails.SingleClassRailTickets[ticketFareCount].Tickets[i].Type;
                            $scope.ticketDescription = $scope.rails.SingleClassRailTickets[ticketFareCount].Tickets[i].Description;
                        }
                        if (i < $scope.outwardJourneyAvailableTrains) {
                                onwardsTicketsGroupedByTicketFare.push($scope.rails.SingleClassRailTickets[ticketFareCount].Tickets[i]);
                        } else {
                            returnTicketsGroupedByTicketFare.push($scope.rails.SingleClassRailTickets[ticketFareCount].Tickets[i]);
                        }
                    }

                    onwardsTicketsGroupedByTicketFare = addDummyTicketDetails(onwardsTicketsGroupedByTicketFare);
                    returnTicketsGroupedByTicketFare = addDummyTicketDetails(returnTicketsGroupedByTicketFare);

                    const groupTicketDetails = {
                        Name: $scope.ticketName,
                        Description: $scope.ticketDescription,
                        Fare: $scope.ticketFare,
                        TicketoutwardJourney: onwardsTicketsGroupedByTicketFare,
                        TicketReturnJourney: returnTicketsGroupedByTicketFare,
                        Type: $scope.ticketType,
                        RteRestrict: $scope.RteRestrict,
                    };
                    $scope.singleClassTicketGroupbyName.push(groupTicketDetails);
                    $scope.ticketName = '';
                    $scope.ticketType = '';
                    $scope.ticketDescription = '';
                    $scope.RteRestrict = '';
                }
                }


                //return Class Ticket
                for (const ticketFareCount in $scope.rails.ReturnClassRailTickets) {
                    if ($scope.rails.ReturnClassRailTickets.hasOwnProperty(ticketFareCount)) {
                    $scope.ticketName = '';
                    $scope.ticketType = '';
                    $scope.ticketDescription = '';
                    $scope.RteRestrict = '';
                    $scope.ticketFare = $scope.rails.ReturnClassRailTickets[ticketFareCount].Fare;
                    $scope.isPromoFare = $scope.rails.ReturnClassRailTickets[ticketFareCount].IsPromoFare;
                    $scope.RteRestrict = $scope.rails.ReturnClassRailTickets[ticketFareCount].RouteRestriction;
                    let onwardsTicketsGroupedByTicketFare = [];
                    let returnTicketsGroupedByTicketFare = [];
                    for (let i = 0; i < $scope.rails.ReturnClassRailTickets[ticketFareCount].Tickets.length; i++) {
                        if ($scope.ticketName === null || $scope.ticketName === '') {
                            $scope.ticketName = $scope.rails.ReturnClassRailTickets[ticketFareCount].Tickets[i].Name;
                            $scope.ticketType = $scope.rails.ReturnClassRailTickets[ticketFareCount].Tickets[i].Type;
                            $scope.ticketDescription = $scope.rails.ReturnClassRailTickets[ticketFareCount].Tickets[i].Description;
                        }
                        if (i < $scope.outwardJourneyAvailableTrains) {
                            onwardsTicketsGroupedByTicketFare.push($scope.rails.ReturnClassRailTickets[ticketFareCount].Tickets[i]);
                        } else {
                            returnTicketsGroupedByTicketFare.push($scope.rails.ReturnClassRailTickets[ticketFareCount].Tickets[i]);
                        }
                    }

                    onwardsTicketsGroupedByTicketFare = addDummyTicketDetails(onwardsTicketsGroupedByTicketFare);
                    returnTicketsGroupedByTicketFare = addDummyTicketDetails(returnTicketsGroupedByTicketFare);

                    const groupTicketDetails = {
                        Name: $scope.ticketName,
                        Description: $scope.ticketDescription,
                        Fare: $scope.ticketFare,
                        TicketoutwardJourney: onwardsTicketsGroupedByTicketFare,
                        TicketReturnJourney: returnTicketsGroupedByTicketFare,
                        Type: $scope.ticketType,
                        RteRestrict: $scope.RteRestrict,
                        IsPromoFare: $scope.isPromoFare,
                    };
                    $scope.returnClassTicketGroupbyName.push(groupTicketDetails);
                    $scope.ticketName = '';
                    $scope.ticketType = '';
                    $scope.ticketDescription = '';
                    $scope.RteRestrict = '';
                    $scope.isPromoFare = '';
                }
                }

                //first Class Ticket
                for (const ticketFareCount in $scope.rails.FirstClassRailTickets) {
                    if ($scope.rails.FirstClassRailTickets.hasOwnProperty(ticketFareCount)) {
                    $scope.ticketName = '';
                    $scope.ticketType = '';
                    $scope.ticketDescription = '';
                    $scope.RteRestrict = '';
                    $scope.ticketFare = $scope.rails.FirstClassRailTickets[ticketFareCount].Fare;
                    $scope.RteRestrict = $scope.rails.FirstClassRailTickets[ticketFareCount].RouteRestriction;
                    let onwardsTicketsGroupedByTicketFare = [];
                    let returnTicketsGroupedByTicketFare = [];
                    for (let i = 0; i < $scope.rails.FirstClassRailTickets[ticketFareCount].Tickets.length; i++) {
                        if ($scope.ticketName === null || $scope.ticketName === '') {
                            $scope.ticketName = $scope.rails.FirstClassRailTickets[ticketFareCount].Tickets[i].Name;
                            $scope.ticketType = $scope.rails.FirstClassRailTickets[ticketFareCount].Tickets[i].Type;
                            $scope.ticketDescription = $scope.rails.FirstClassRailTickets[ticketFareCount].Tickets[i].Description;
                        }
                        if (i < $scope.outwardJourneyAvailableTrains) {
                            onwardsTicketsGroupedByTicketFare.push($scope.rails.FirstClassRailTickets[ticketFareCount].Tickets[i]);
                        } else {
                            returnTicketsGroupedByTicketFare.push($scope.rails.FirstClassRailTickets[ticketFareCount].Tickets[i]);
                        }
                    }

                    onwardsTicketsGroupedByTicketFare = addDummyTicketDetails(onwardsTicketsGroupedByTicketFare);
                    returnTicketsGroupedByTicketFare = addDummyTicketDetails(returnTicketsGroupedByTicketFare);

                    const groupTicketDetails = {
                        Name: $scope.ticketName,
                        Description: $scope.ticketDescription,
                        Fare: $scope.ticketFare,
                        TicketoutwardJourney: onwardsTicketsGroupedByTicketFare,
                        TicketReturnJourney: returnTicketsGroupedByTicketFare,
                        Type: $scope.ticketType,
                        RteRestrict: $scope.RteRestrict,
                    };
                    $scope.firstClassTicketGroupbyName.push(groupTicketDetails);
                    $scope.ticketName = '';
                    $scope.ticketType = '';
                    $scope.ticketDescription = '';
                    $scope.RteRestrict = '';
                }
                }
                $scope.ticketGroupbyName.push.apply($scope.ticketGroupbyName, $scope.firstClassTicketGroupbyName);
                $scope.ticketGroupbyName.push.apply($scope.ticketGroupbyName, $scope.returnClassTicketGroupbyName);
                $scope.ticketGroupbyName.push.apply($scope.ticketGroupbyName, $scope.singleClassTicketGroupbyName);
            }
            $scope.timediff = function(start, end) {
                if (start === '-') {
                    return '-';
                }

                    return moment.utc(moment(end).diff(moment(start))).format('hh:mm');


            };
            $scope.totalTicketCost = function(onwardTicket, returnTicket) {
                return onwardTicket + returnTicket;
            };

            function getPassengerCount(itemArray, property, childProperty) {
                let total = 0;
                for (let i = 0, _len = itemArray.length; i < _len; i++) {
                    if (childProperty !== null && childProperty !== '') {
                        total += itemArray[i][property][childProperty];
                    } else {
                        total += itemArray[i][property];
                    }
                }
                return total;
            }

            $scope.params.isOutwardTicketSelected = false;
            $scope.params.isReturnTicketSelected = false;
            $scope.params.hasReturnTicketCommonPrice = false;
            $scope.params.selectedOutwardTicketDetails = '';
            $scope.params.adultCount = '';
            $scope.params.ChildrenCount = '';
            $scope.params.selectedReturnTicketDetails = '';
            $scope.showLondonCards = false;
            $scope.rdb = null;
            $scope.moment = moment;
            function isSeatPreferencesVisible() {
                const isSeatPrefVisible = DEFAULT_SEAT_RESERVATION_AND_PREFERENCES;
                $scope.params.returnSeatReservationYesOrNo = isSeatPrefVisible;
                $scope.params.outwardSeatReservationYesOrNo = isSeatPrefVisible;
                return isSeatPrefVisible;
            }

            $scope.selectedOutwardJourney = function(ticketTypeName, TicketoutwardJourney) { // eslint-disable-line
                if ($scope.params.isReturnTicketSelected) {
                    if (TicketoutwardJourney.FareSrc === 'R') {
                        if ($scope.params.selectedReturnTicketDetails.Type !== TicketoutwardJourney.Type) {
                            angular.element('[id=\'' + $scope.params.selectedReturnTicketDetails.UniqueId + '-' + $scope.params.selectedReturnTicketDetails.Total + '\']').filter(':checked').prop('checked', false);
                            angular.element('.matrix-ticket, .col-sm-2').removeClass('matrix-radio-return-click');
                            $scope.params.isReturnTicketSelected = false;
                            $scope.params.selectedReturnTicketDetails = '';
                        } else if ($scope.params.selectedReturnTicketDetails.Total !== TicketoutwardJourney.Total) {
                                angular.element('[id=\'' + $scope.params.selectedReturnTicketDetails.UniqueId + '-' + $scope.params.selectedReturnTicketDetails.Total + '\']').filter(':checked').prop('checked', false);
                                angular.element('.matrix-ticket, .col-sm-2').removeClass('matrix-radio-return-click');
                                $scope.params.isReturnTicketSelected = false;
                                $scope.params.selectedReturnTicketDetails = '';
                            }
                    } else if ($scope.params.selectedReturnTicketDetails.FareSrc === 'R') {
                            angular.element('[id=\'' + $scope.params.selectedReturnTicketDetails.UniqueId + '-' + $scope.params.selectedReturnTicketDetails.Total + '\']').filter(':checked').prop('checked', false);
                            angular.element('.matrix-ticket, .col-sm-2').removeClass('matrix-radio-return-click');
                            $scope.params.isReturnTicketSelected = false;
                            $scope.params.selectedReturnTicketDetails = '';
                        }
                }
                $scope.params.isOutwardTicketSelected = true;
                $scope.params.selectedOutwardTicketDetails = TicketoutwardJourney;
                $scope.params.adultCount = TicketoutwardJourney.Adults.Num + TicketoutwardJourney.AccAdults.Num + getPassengerCount(TicketoutwardJourney.AppliedRailCard, 'AdultDiscs', 'Num');
                $scope.params.ChildrenCount = TicketoutwardJourney.Children.Num + TicketoutwardJourney.AccChildren.Num + getPassengerCount(TicketoutwardJourney.AppliedRailCard, 'ChildDiscs', 'Num');
                if (TicketoutwardJourney.RailJourneyDetail.AvailableAddOns.TravelCards === 'Peak'
                    || TicketoutwardJourney.RailJourneyDetail.AvailableAddOns.TravelCards === 'OffPeak') {
                    $scope.showLondonCards = true;
                }
            };

            $scope.selectedReturnJourney = function(ticketTypeName, TicketReturnJourney) { // eslint-disable-line
                if ($scope.params.isOutwardTicketSelected) {
                    if (TicketReturnJourney.FareSrc === 'R') {
                        if ($scope.params.selectedOutwardTicketDetails.Type !== TicketReturnJourney.Type) {
                            angular.element('[id=\'' + $scope.params.selectedOutwardTicketDetails.UniqueId + '-' + $scope.params.selectedOutwardTicketDetails.Total + '\']').filter(':checked').prop('checked', false);
                            angular.element('.matrix-ticket, .col-sm-2').removeClass('matrix-radio-onwards-click');
                            $scope.params.isOutwardTicketSelected = false;
                            $scope.params.selectedOutwardTicketDetails = '';
                        } else if ($scope.params.selectedOutwardTicketDetails.Total !== TicketReturnJourney.Total) {
                                angular.element('[id=\'' + $scope.params.selectedOutwardTicketDetails.UniqueId + '-' + $scope.params.selectedOutwardTicketDetails.Total + '\']').filter(':checked').prop('checked', false);
                                angular.element('.matrix-ticket, .col-sm-2').removeClass('matrix-radio-onwards-click');
                                $scope.params.isOutwardTicketSelected = false;
                                $scope.params.selectedOutwardTicketDetails = '';
                            }
                    } else if ($scope.params.selectedOutwardTicketDetails.FareSrc === 'R') {
                            angular.element('[id=\'' + $scope.params.selectedOutwardTicketDetails.UniqueId + '-' + $scope.params.selectedOutwardTicketDetails.Total + '\']').filter(':checked').prop('checked', false);
                            angular.element('.matrix-ticket, .col-sm-2').removeClass('matrix-radio-onwards-click');
                            $scope.params.isOutwardTicketSelected = false;
                            $scope.params.selectedOutwardTicketDetails = '';
                        }
                }

                $scope.params.isReturnTicketSelected = true;
                $scope.params.hasReturnTicketCommonPrice = TicketReturnJourney.FareSrc === 'R';
                $scope.params.selectedReturnTicketDetails = TicketReturnJourney;
                $scope.params.adultCount = TicketReturnJourney.Adults.Num + TicketReturnJourney.AccAdults.Num + getPassengerCount(TicketReturnJourney.AppliedRailCard, 'AdultDiscs', 'Num');
                $scope.params.ChildrenCount = TicketReturnJourney.Children.Num + TicketReturnJourney.AccChildren.Num + getPassengerCount(TicketReturnJourney.AppliedRailCard, 'ChildDiscs', 'Num');
                if (TicketReturnJourney.RailJourneyDetail.AvailableAddOns.TravelCards === 'Peak'
                    || TicketReturnJourney.RailJourneyDetail.AvailableAddOns.TravelCards === 'OffPeak') {
                    $scope.showLondonCards = true;
                }
            };

            $scope.cheapestOnwardsJourneyInfo = function(uniqueId) { // eslint-disable-line
                for (const ticketFareCount in $scope.ticketGroupbyName) {
                    if ($scope.ticketGroupbyName.hasOwnProperty(ticketFareCount)) {
                    for (let i = 0; i < $scope.ticketGroupbyName[ticketFareCount].TicketoutwardJourney.length; i++) {
                        if ($scope.ticketGroupbyName[ticketFareCount].TicketoutwardJourney[i].UniqueId === uniqueId) {
                            $scope.params.isOutwardTicketSelected = true;
                            $scope.params.selectedOutwardTicketDetails = $scope.ticketGroupbyName[ticketFareCount].TicketoutwardJourney[i];
                            const tkt = $scope.ticketGroupbyName[ticketFareCount].TicketoutwardJourney[i];
                            $scope.params.adultCount = tkt.Adults.Num + tkt.AccAdults.Num + getPassengerCount(tkt.AppliedRailCard, 'AdultDiscs', 'Num');
                            $scope.params.ChildrenCount = tkt.Children.Num + tkt.AccChildren.Num + getPassengerCount(tkt.AppliedRailCard, 'ChildDiscs', 'Num');
                            if ($scope.params.selectedOutwardTicketDetails.RailJourneyDetail.AvailableAddOns.TravelCards === 'Peak'
                                || $scope.params.selectedOutwardTicketDetails.RailJourneyDetail.AvailableAddOns.TravelCards === 'OffPeak') {
                                $scope.showLondonCards = true;
                            }
                        }
                    }
                    }
                }
                if ($scope.params.isReturnTicketSelected) {
                    if ($scope.params.selectedOutwardTicketDetails.FareSrc === 'R') {
                        if ($scope.params.selectedReturnTicketDetails.Type !== $scope.params.selectedOutwardTicketDetails.Type) {
                            angular.element('[id=\'' + $scope.params.selectedReturnTicketDetails.UniqueId + '-' + $scope.params.selectedReturnTicketDetails.Total + '\']').filter(':checked').prop('checked', false);
                            angular.element('.matrix-ticket, .col-sm-2').removeClass('matrix-radio-return-click');
                            $scope.params.isReturnTicketSelected = false;
                            $scope.params.selectedReturnTicketDetails = '';
                        } else if ($scope.params.selectedReturnTicketDetails.Total !== $scope.params.selectedOutwardTicketDetails.Total) {
                                angular.element('[id=\'' + $scope.params.selectedReturnTicketDetails.UniqueId + '-' + $scope.params.selectedReturnTicketDetails.Total + '\']').filter(':checked').prop('checked', false);
                                angular.element('.matrix-ticket, .col-sm-2').removeClass('matrix-radio-return-click');
                                $scope.params.isReturnTicketSelected = false;
                                $scope.params.selectedReturnTicketDetails = '';
                            }
                    } else if ($scope.params.selectedReturnTicketDetails.FareSrc === 'R') {
                            angular.element('[id=\'' + $scope.params.selectedReturnTicketDetails.UniqueId + '-' + $scope.params.selectedReturnTicketDetails.Total + '\']').filter(':checked').prop('checked', false);
                            angular.element('.matrix-ticket, .col-sm-2').removeClass('matrix-radio-return-click');
                            $scope.params.isReturnTicketSelected = false;
                            $scope.params.selectedReturnTicketDetails = '';
                        }
                }
            };
            $scope.cheapReturnJourneyInfo = function(uniqueId) { // eslint-disable-line
                for (const ticketFareCount in $scope.ticketGroupbyName) {
                    if ($scope.ticketGroupbyName.hasOwnProperty(ticketFareCount)) {
                    for (let i = 0; i < $scope.ticketGroupbyName[ticketFareCount].TicketReturnJourney.length; i++) {
                        if ($scope.ticketGroupbyName[ticketFareCount].TicketReturnJourney[i].UniqueId === uniqueId) {
                            $scope.params.isReturnTicketSelected = true;
                            $scope.params.hasReturnTicketCommonPrice = $scope.ticketGroupbyName[ticketFareCount].TicketReturnJourney[i].FareSrc === 'R';
                            $scope.params.selectedReturnTicketDetails = $scope.ticketGroupbyName[ticketFareCount].TicketReturnJourney[i];
                            const tkt = $scope.ticketGroupbyName[ticketFareCount].TicketReturnJourney[i];
                            $scope.params.adultCount = tkt.Adults.Num + tkt.AccAdults.Num + getPassengerCount(tkt.AppliedRailCard, 'AdultDiscs', 'Num');
                            $scope.params.ChildrenCount = tkt.Children.Num + tkt.AccChildren.Num + getPassengerCount(tkt.AppliedRailCard, 'ChildDiscs', 'Num');
                            if ($scope.params.selectedReturnTicketDetails.RailJourneyDetail.AvailableAddOns.TravelCards === 'Peak'
                                || $scope.params.selectedReturnTicketDetails.RailJourneyDetail.AvailableAddOns.TravelCards === 'OffPeak') {
                                $scope.showLondonCards = true;
                            }
                        }
                    }
                    }
                }
                if ($scope.params.isOutwardTicketSelected) {
                    if ($scope.params.selectedReturnTicketDetails.FareSrc === 'R') {
                        if ($scope.params.selectedOutwardTicketDetails.Type !== $scope.params.selectedReturnTicketDetails.Type) {
                            angular.element('[id=\'' + $scope.params.selectedOutwardTicketDetails.UniqueId + '-' + $scope.params.selectedOutwardTicketDetails.Total + '\']').filter(':checked').prop('checked', false);
                            angular.element('.matrix-ticket, .col-sm-2').removeClass('matrix-radio-onwards-click');
                            $scope.params.isOutwardTicketSelected = false;
                            $scope.params.selectedOutwardTicketDetails = '';
                        } else if ($scope.params.selectedOutwardTicketDetails.Total !== $scope.params.selectedReturnTicketDetails.Total) {
                                angular.element('[id=\'' + $scope.params.selectedOutwardTicketDetails.UniqueId + '-' + $scope.params.selectedOutwardTicketDetails.Total + '\']').filter(':checked').prop('checked', false);
                                angular.element('.matrix-ticket, .col-sm-2').removeClass('matrix-radio-onwards-click');
                                $scope.params.isOutwardTicketSelected = false;
                                $scope.params.selectedOutwardTicketDetails = '';
                            }
                    } else if ($scope.params.selectedOutwardTicketDetails.FareSrc === 'R') {
                            angular.element('[id=\'' + $scope.params.selectedOutwardTicketDetails.UniqueId + '-' + $scope.params.selectedOutwardTicketDetails.Total + '\']').filter(':checked').prop('checked', false);
                            angular.element('.matrix-ticket, .col-sm-2').removeClass('matrix-radio-onwards-click');
                            $scope.params.isOutwardTicketSelected = false;
                            $scope.params.selectedOutwardTicketDetails = '';
                        }
                }
            };

            $scope.params.trainTicketRules = function(RteRestrict) {
                let restrictDescription = '';
                for (let ticketRestrictCount = 0; ticketRestrictCount < $scope.rails.RailRouteRestrictionInformations.length; ticketRestrictCount++) {
                    if (RteRestrict === $scope.rails.RailRouteRestrictionInformations[ticketRestrictCount].Code) {
                        restrictDescription = $scope.rails.RailRouteRestrictionInformations[ticketRestrictCount].Description;
                    }

                }
                if (restrictDescription === '.') {
                    restrictDescription = '';
                }
                return restrictDescription;
            };

            $scope.railJourneyDetails = '';
            $scope.railJourneyInfo = function(JourneyDetail) {
                $scope.railJourneyDetails = JourneyDetail;

            };

            $scope.findEarlierJournies = function(direction) {
                let laterThanDatetime;
                let earlierDate;
                let earlierTime;
                let journeyDetail;

                Object.assign($scope.params, {
                    selectedReturnTicketDetails: '',
                    selectedOutwardTicketDetails: '',
                    isReturnTicketSelected: false,
                    isOutwardTicketSelected: false,
                });

                if (direction === 'outward') {
                    journeyDetail = $scope.outwardsJourneyDetails[4 - $scope.noOfOutwardJourney];
                    laterThanDatetime = moment(journeyDetail.JourneyDetail.ArrivalDate, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD HH:mm').split(' ');
                    earlierDate = laterThanDatetime[0];
                    earlierTime = laterThanDatetime[1].split(':');
                    $scope.params.RailTicketSearchSegments[0].DepartureDate = moment(journeyDetail.JourneyDetail.ArrivalDate, 'YYYY-MM-DD');
                    $scope.params.RailTicketSearchSegments[0]._date = moment(journeyDetail.JourneyDetail.ArrivalDate, 'YYYY-MM-DD');
                    $scope.params.RailTicketSearchSegments[0].DHour.Text = earlierTime[0];
                    $scope.params.RailTicketSearchSegments[0].DHour.Value = earlierTime[0];
                    $scope.params.RailTicketSearchSegments[0].DMinutes.Text = earlierTime[1];
                    $scope.params.RailTicketSearchSegments[0].DMinutes.Value = earlierTime[1];
                    $scope.params.RailTicketSearchSegments[0]._isArrivalTime = true;
                } else if (direction === 'return') {
                    journeyDetail = $scope.returnJourneyDetails[4 - $scope.noOfReturnJourney];
                    laterThanDatetime = moment(journeyDetail.JourneyDetail.ArrivalDate, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD HH:mm').split(' ');
                    earlierDate = laterThanDatetime[0];
                    earlierTime = laterThanDatetime[1].split(':');
                    $scope.params.RailTicketSearchSegments[1].DepartureDate = moment(journeyDetail.JourneyDetail.ArrivalDate, 'YYYY-MM-DD');
                    $scope.params.RailTicketSearchSegments[1]._date = moment(journeyDetail.JourneyDetail.ArrivalDate, 'YYYY-MM-DD');
                    $scope.params.RailTicketSearchSegments[1].RHour.Text = earlierTime[0];
                    $scope.params.RailTicketSearchSegments[1].RHour.Value = earlierTime[0];
                    $scope.params.RailTicketSearchSegments[1].RMinutes.Text = earlierTime[1];
                    $scope.params.RailTicketSearchSegments[1].RMinutes.Value = earlierTime[1];
                    $scope.params.RailTicketSearchSegments[1]._isArrivalTime = true;
                }

                railsFactory.getEarlierOrLaterJournies($scope.params, earlierDate, earlierTime, journeyDetail.JourneyDetail.Direction, true)
                        .then((data) => {
                            const errors = data.ErrorReport && data.ErrorReport.ResponseError;
                            if (errors && errors.length) {
                                const errorMessages = errors.map((ErrorDescription) => ErrorDescription);
                                $scope.ErroMessage = l10nService.localize(errorMessages[0].ErrorDescription);
                                return;
                            }
                            $scope.rails = data;
                            bindJourneyDetails();
                            bindTickets();
                        });
            };

            $scope.findLaterJournies = function(direction) {
                let laterThanDatetime;
                let laterDate;
                let laterTime;
                let journeyDetail;

                Object.assign($scope.params, {
                    selectedReturnTicketDetails: '',
                    selectedOutwardTicketDetails: '',
                    isReturnTicketSelected: false,
                    isOutwardTicketSelected: false,
                });

                if (direction === 'outward') {
                    journeyDetail = $scope.outwardsJourneyDetails[3];
                    laterThanDatetime = moment(journeyDetail.JourneyDetail.DepartureDate, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD HH:mm').split(' ');
                    laterDate = laterThanDatetime[0];
                    laterTime = laterThanDatetime[1].split(':');
                    $scope.params.RailTicketSearchSegments[0].DepartureDate = moment(journeyDetail.JourneyDetail.DepartureDate, 'YYYY-MM-DD');
                    $scope.params.RailTicketSearchSegments[0]._date = moment(journeyDetail.JourneyDetail.DepartureDate, 'YYYY-MM-DD');
                    $scope.params.RailTicketSearchSegments[0].DHour.Text = laterTime[0];
                    $scope.params.RailTicketSearchSegments[0].DHour.Value = laterTime[0];
                    $scope.params.RailTicketSearchSegments[0].DMinutes.Text = laterTime[1];
                    $scope.params.RailTicketSearchSegments[0].DMinutes.Value = laterTime[1];
                    $scope.params.RailTicketSearchSegments[0]._isArrivalTime = false;
                } else if (direction === 'return') {
                    journeyDetail = $scope.returnJourneyDetails[3];
                    laterThanDatetime = moment(journeyDetail.JourneyDetail.DepartureDate, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD HH:mm').split(' ');
                    laterDate = laterThanDatetime[0];
                    laterTime = laterThanDatetime[1].split(':');
                    $scope.params.RailTicketSearchSegments[1].DepartureDate = moment(journeyDetail.JourneyDetail.DepartureDate, 'YYYY-MM-DD');
                    $scope.params.RailTicketSearchSegments[1]._date = moment(journeyDetail.JourneyDetail.DepartureDate, 'YYYY-MM-DD');
                    $scope.params.RailTicketSearchSegments[1].RHour.Text = laterTime[0];
                    $scope.params.RailTicketSearchSegments[1].RHour.Value = laterTime[0];
                    $scope.params.RailTicketSearchSegments[1].RMinutes.Text = laterTime[1];
                    $scope.params.RailTicketSearchSegments[1].RMinutes.Value = laterTime[1];
                    $scope.params.RailTicketSearchSegments[1]._isArrivalTime = false;
                }
                railsFactory.getEarlierOrLaterJournies($scope.params, laterDate, laterTime, journeyDetail.JourneyDetail.Direction, false)
                        .then((response) => {
                            const errors = response && response.ErrorReport && response.ErrorReport.ResponseError;
                            if (errors && errors.length) {
                                const errorMessages = errors.map((ErrorDescription) => ErrorDescription);
                                $scope.ErroMessage = l10nService.localize(errorMessages[0].ErrorDescription);
                                return;
                            }
                            $scope.rails = response;
                            bindJourneyDetails();
                            bindTickets();
                        }
                        );
            };

            if (angular.isDefined($scope.params.selectedOutwardTicketDetails) && $scope.params.selectedOutwardTicketDetails !== '') {
                if ($scope.params.selectedOutwardTicketDetails.RailJourneyDetail.ReservationRequired !== 1) {
                    $scope.params.outwardSeatReservationYesOrNo = true;
}
            }
            if (angular.isDefined($scope.params.selectedReturnTicketDetails) && $scope.params.selectedReturnTicketDetails !== '') {
                if ($scope.params.selectedReturnTicketDetails.RailJourneyDetail.ReservationRequired !== 1) {
                    $scope.params.returnSeatReservationYes = true;
                }
            }

            getRailReservationPreferenceOptions();

            getRailTravelCardOptions();

            getFormatedDepartureDate();

            $scope.showLondonCards = false;

            async function getRailReservationPreferenceOptions() {
                const {data} = await railsFactory.getRailReservationPreferenceOptions();
                $scope.preferences = data.Preferences;

                $scope.options.RRPreferenceOptionsDirection = data.Preferences.filter((pref) => pref.GroupName === 'Direction');
                $scope.options.RRPreferenceOptionsPosition = data.Preferences.filter((pref) => pref.GroupName === 'Position');
                $scope.options.RRPreferenceOptionsEnvironment = data.Preferences.filter((pref) => pref.GroupName === 'Environment');
                $scope.options.RRPreferenceOptionsNearPreferences = data.Preferences.filter((pref) => pref.GroupName === 'Near Preferences');
                $scope.options.RRPreferenceOptionsNearPhysicalRequirements = data.Preferences.filter((pref) => pref.GroupName === 'Physical Requirements');

                $scope.options.RRPreferenceOptionsDirection.splice(0, 0, {Code: '', Group: '', GroupName: '', Name: l10nService.localize('No preferences')});
                $scope.options.RRPreferenceOptionsPosition.splice(0, 0, {Code: '', Group: '', GroupName: '', Name: l10nService.localize('No preferences')});
                $scope.options.RRPreferenceOptionsEnvironment.splice(0, 0, {Code: '', Group: '', GroupName: '', Name: l10nService.localize('No preferences')});

                $scope.params.RRPreferenceOptionsDirection = $scope.options.RRPreferenceOptionsDirection[0].Code;
                $scope.params.RRPreferenceOptionsPosition = $scope.options.RRPreferenceOptionsPosition[0].Code;
                $scope.params.RRPreferenceOptionsEnvironment = $scope.options.RRPreferenceOptionsEnvironment[0].Code;
            }

            function getRailTravelCardOptions() {
                railsFactory.getRailTravelCardOptions($scope.params.RailTicketSearchSegments[0]._date).then(
                    function(response) {
                        $scope.options.RailTravelCardOptions = response.data.TravelCard;
                        $scope.options.RailTravelCardOptions.splice(0, 0, {AdultFare: 0,
                            CardType: '',
                            Description: '',
                            DisplayString: 'None',
                            TermsAndConditions: null,
                            Zones: '',
                        });
                        $scope.params.TravelCards = $scope.options.RailTravelCardOptions[0];
                    }
                );
            }
            function getFormatedDepartureDate() {
                if ($scope.params.RailTicketSearchSegments[0]._date !== '') {
                    $scope.formatedDeaprtDT = timeService.getDateInUserRegionFormatOrCurrentDate($scope.params.RailTicketSearchSegments[0]._date).format(regionalSettings.fullDayMonDateYearFormat);
                }
            }
            function hasFormErrors() {
                return $scope.form && $scope.form.DeliveryOptions && $scope.form.DeliveryOptions.$invalid;
            }

            $scope.toggleShowSeatOptions = function() {
                $scope.showSeatPreferences = !$scope.showSeatPreferences;
            };

            $scope.toggleShowTravelCards = function() {
                $scope.showTravelCards = !$scope.showTravelCards;
            };

            $scope.toggleShowDeliveryOptions = function() {
                $scope.showDevliveryPreferences = !$scope.showDevliveryPreferences;
            };
            $scope.postAddressError = false;
            $scope.corpKioskError = false;
            $scope.kioskError = false;
            $scope.addToBasket = function(popup) { // eslint-disable-line

                if (hasFormErrors()) {
                    $scope.form.DeliveryOptions.$setSubmitted();
                    return;
                }

                $scope.postAddressError = false;
                $scope.kioskError = false;
                const {
                    POST,
                    NEXTDAY,
                    SAMEDAYOFFICEDROP,
                    KIOSK,
                    COLLECTION,
                    CORPORATEKIOSK,
                    MOBILE,
                    PRINTYOUROWN,
                } = deliveryOptionTypes;

                const isPostMethod = [POST, NEXTDAY]
                    .map(({typeName}) => typeName)
                    .includes($scope.params.TicketDeliveryOption.TypeName);
                const isAddressSelected = $scope.params.TicketByPostAddressType
                    && $scope.params.TicketByPostAddressType.Id;

                if (isPostMethod && !isAddressSelected) {
                    $scope.addressErrorVisible = !$scope.params.TicketByPostAddressType.Id;
                    return false;
                }

                const {TypeName: selectedOption} = $scope.params.TicketDeliveryOption;

                if (selectedOption === SAMEDAYOFFICEDROP.typeName) {
                    if (!validateCorpPrinter()) {
                        return false;
                    }
                }

                if ([KIOSK.typeName, COLLECTION.typeName].includes(selectedOption)) {
                    if (!$scope.params.TicketCollectionStation) {
                        $scope.kioskError = true;
                        return false;
                    }
                }

                if ([POST.typeName, NEXTDAY.typeName].includes(selectedOption)) {
                    if (!isAddressFormValid()) {
                        return false;
                    }
                }

                if ($scope.params.TicketDeliveryOption.TypeName === CORPORATEKIOSK.typeName) {
                    if (!validateCorpKiosk()) {
                        return false;
                    }
                }

                if ($scope.params.TicketDeliveryOption.TypeName === MOBILE.typeName) {
                    if (!validateMobileDOName()) {
                        return false;
                    }
                }

                if ($scope.params.TicketDeliveryOption.TypeName === PRINTYOUROWN.typeName) {
                    if (!validatePYODOName()) {
                        return false;
                    }
                }

                if (!validateBasketItems()) {
                    return false;
                }

                const isRoundtrip = railsFactory.params.flightType === 'roundtrip';
                const searchId = railsFactory.params.SearchId;

                const basketRail = railsService.processRailBeforeInsertToBasket(railsFactory.params, searchId, isRoundtrip);

                if ($stateParams.rebook) {
                    const tripId = $stateParams.rebook.tripId;
                    railAmendmentService.createRailRebookCandidate(basketRail, $stateParams.rebook)
                        .then((recommendationId) => {
                            railAmendmentService.navigateToCheckoutWithNewRailGroup(recommendationId, tripId);
                        });
                    return;
                }
                basketService.addRail(basketRail);
                popup.close();
            };

            $scope.basketErrorMsg = false;
            $scope.msgTextBasket = '';

            function isAddressFormValid() {
                const {
                    TicketByPostCode,
                    TicketByPostAddressLines: {Line1, Line2} = {
                        Line1: '',
                        Line2: '',
                },
                TicketByPostName,
                } = $scope.params;

                if (!TicketByPostCode || !Line1 || !Line2) {
                    $scope.postAddressError = true;
                    return false;
                }

                if (!TicketByPostName) {
                    $scope.postNameError = true;
                    return false;
                }
                return true;
            }

            function validateBasketItems() {
                $scope.basketErrorMsg = false;
                const basketRailItems = basketService.getRails();
                if (basketRailItems) {
                    if (basketRailItems.length >= 8) {
                        $scope.basketErrorMsg = true;
                        $scope.msgTextBasket = 'Shopping basket is full. You can only buy 8 tickets at once.';
                        return false;
                    }
                }
                return true;
            }

            $scope.ValidateCorpKiosk = function() {
                return validateCorpKiosk();
            };

            function validateCorpKiosk() {
                $scope.corpKioskError = false;
                if ($scope.params.TicketDeliveryOption.TypeName === 'CorporateKiosk') {
                    if ($scope.params.TicketCollectionCorpKiosk === '' || angular.isUndefined($scope.params.TicketCollectionCorpKiosk)) {
                        $scope.corpKioskError = true;
                        return false;
                    }

                        return true;

                }

            }

            $scope.corpPrinterError = false;

            $scope.ValidateCorpPrinter = function() {
                return validateCorpPrinter();
            };
            function validateCorpPrinter() {
                $scope.corpPrinterError = false;
                if ($scope.params.TicketDeliveryOption.TypeName === 'SameDayOfficeDrop') {
                    if ($scope.params.TicketByCorpPrinter === '' || angular.isUndefined($scope.params.TicketByCorpPrinter)) {
                        $scope.corpPrinterError = true;
                        return false;
                    }

                        return true;

                }

            }

            $scope.MobileError = false;

            $scope.ValidateMobileDOName = function() {
                return validateMobileDOName();
            };
            function validateMobileDOName() {
                $scope.MobileError = false;
                if ($scope.params.TicketDeliveryOption.TypeName === 'Mobile') {
                    if ($scope.params.TicketByMobileName === '' || angular.isUndefined($scope.params.TicketByMobileName)) {
                        $scope.MobileError = true;
                        return false;
                    }
                        return true;
                }
            }

            $scope.PYOError = 0;
            function validatePYODOName() {
                $scope.MobileError = false;
                if ($scope.params.TicketDeliveryOption.TypeName === 'PrintYourOwn') {
                    const travellersCount = $scope.params.adultCount + $scope.params.ChildrenCount;
                    for (let i = 1; i <= travellersCount; i++) {
                        if (!$scope.params.PassengerNames[i]) {
                            $scope.PYOError = [i];
                            return false;
                        }
                    }
                    return true;
                }
            }
            $scope.validatePassengerNames = function() {
                $scope.PYOError = 0;
            };
            $scope.validateMobilePassengerName = function() {
                $scope.MobileError = false;
            };

            $scope.updateDeliveryMethod = function(viewValue) {
                $scope.params.TicketDeliveryOption = viewValue;
            };

            function getAllStations() {
                let allStations = [];
                railsFactory.getKioskRailStations()
                    .then(({data}) => {
                        $scope.params.TicketCollectionStation = '';
                        allStations = data;
                        allStations.sort(function(first, second) {
                            if (first.DisplayString > second.DisplayString) {
                                return 1;
                            }
                            return (second.DisplayString > first.DisplayString) ? -1 : 0;
                        });
                        $scope.options.AllRailStations = allStations;
                        if ($scope.options.AllRailStations.filter((station) => station.Code === $scope.params.selectedOutwardTicketDetails.RailJourneyDetail.OriginCode).length > 0) {
                            $scope.params.TicketCollectionStation = $scope.params.selectedOutwardTicketDetails.RailJourneyDetail.OriginCode;
                        }
                        $scope.params.TicketCollectionEmail = $scope.user.Email;
                    });
            }

            function getAllCorpkiosks() {
                let allCorpkiosks = [];
                railsFactory.getAllCorpkiosks().then(
                    function(response) {
                        allCorpkiosks = response.data.Kiosk;
                        $scope.options.AllCorpkiosks = allCorpkiosks;
                        $scope.params.TicketCollectionEmail = $scope.user.Email;
                    });
            }

            function getCorpPrinters() {
                let corpPrinters = [];
                railsFactory.getCorpPrinters().then(
                    function(response) {
                        corpPrinters = response.data.RemotePrinterDetails;
                        $scope.options.corpPrintersList = corpPrinters;
                    });
            }

            $scope.params.PassengerNames = [];
            $scope.getNumber = function() {
                const passengerCount = parseInt($scope.params.Travelers.Adult.value, 10) + parseInt($scope.params.Travelers.Child.value, 10);
                return new Array(passengerCount);
            };

            $scope.getAddressLinesCount = function() {
                return new Array(5);
            };
            $scope.getAddressByPostcode = function(postCode) {
                $scope.postCodeErrors = [];

                railsFactory.getAddressByPostcode(postCode)
                    .then(({data}) => {
                        if (data.Address.length > 1) {
                            $scope.params.TicketByPostAddresses = data.Address.map((address, Id) => {
                                const addressLines = _.pick(address, _.identity);
                                const DisplayString = [
                                    addressLines.Line1,
                                    addressLines.Line2,
                                    addressLines.Line3,
                                    addressLines.Line4,
                                    addressLines.Line5,
                                ].join(' ');
                                Object.assign(address, {
                                    Id,
                                    DisplayString,
                                });
                                return address;
                            });
                        } else if (data.Address.length === 1) {
                            $scope.params.TicketByPostAddressLines = data.Address[0];
                        }
                        processErrors(data.ErrorReport);
                    });

                function processErrors(errorReport) {
                    const errors = errorReport && errorReport.ResponseError;
                    if (errors && errors.length) {
                        $scope.postCodeErrors = errors
                            .filter((error) => !!error)
                            .map(({ErrorDescription}) => l10nService.localize(ErrorDescription));
                    }
                }
            };

            $scope.showFlightSearchResultsLink = false;
            showFightSearchResultsLink();

            function showFightSearchResultsLink() {
                if ($stateParams.DomesticSearchGUId !== '0') {
                    $scope.showFlightSearchResultsLink = true;
                    $stateParams.DomesticSearchGUId = null;
                } else {
                    $scope.showFlightSearchResultsLink = false;
                }
            }
            $scope.setDeliveryOptionValues = function() {
                const typeName = $scope.params
                    && $scope.params.TicketDeliveryOption
                    && $scope.params.TicketDeliveryOption.TypeName;

                if (!typeName) {
                    return;
                }

                $scope.disableTravelCard = ['PrintYourOwn', 'Mobile'].includes(typeName);

                if (['Post', 'NextDay'].includes(typeName)) {
                    $scope.params.TicketByPostName = $scope.user.Name;
                }
                $scope.basketErrorMsg = false;
                $scope.msgTextBasket = '';
            };


            $scope.assingSelectedAddress = function() {
                $scope.params.TicketByPostAddressLines = angular.fromJson($scope.params.TicketByPostAddressSelected);
                $scope.params.TicketByPostAddresses = null;
            };
            $scope.backToFlightSearchResults = function() {
                $state.go(flightStates.FLIGHTS_RESULTS);
            };

            $scope.resetTravelOptions = function() {
                $scope.showSeatPreferences = isSeatPreferencesVisible();
                $scope.DeliveryOptions = angular.copy($scope.rails.RailTicketDeliveryOptions);
                $scope.params.TicketCollectionStation = '';
                $scope.params.PassengerNames = [];
                $scope.params.TicketByPostCountry = 'United Kingdom';
                $scope.params.TicketByPostName = $scope.user.Name;
                $scope.params.TicketByPostAddressType = '';
                $scope.params.TicketByPostAddressSelected = '';
                $scope.params.TicketByPostAddressLines = [];
                $scope.params.RRPreferenceOptionsDirection = '';
                $scope.params.RRPreferenceOptionsPosition = '';
                $scope.params.RRPreferenceOptionsEnvironment = '';
                $scope.params.isTableSeatSelected = false;
                $scope.params.isSeatSelectedNearLuggageRack = false;
                $scope.params.isPowerSocketSeatSelected = false;
                $scope.params.isSeatSelectedNearToilet = false;
                $scope.params.TravelCards = '';
                removeUnwantedDOs();
                limitDeliveryOptions();
                $scope.params.TicketDeliveryOption = $scope.DeliveryOptions[0];
                $scope.params.TravelCards = $scope.options.RailTravelCardOptions[0];
                getAllStations();
                getAddressTypes();
                getAllCorpkiosks();
                getCorpPrinters();
                $scope.params.TicketCollectionCorpKiosk = '';
                $scope.params.TicketByMobileName = '';
                $scope.params.TicketByPostAddressDescription = '';
            };
            function removeUnwantedDOs() { // eslint-disable-line
                let itemToRemoveIndex = null;
                let itemTofind;
                const ItemsToRemove = [];
                if ($scope.params.ReturnOrSingleJourney === 'R') {
                    //Removing print your own option
                    //Should consider the selected ticket reservation required flag not the journeydetail's reservationRequired flag
                    if ($scope.params.selectedOutwardTicketDetails.RailJourneyDetail.PYOTicketAvailable !== true
                    || $scope.params.selectedReturnTicketDetails.RailJourneyDetail.PYOTicketAvailable !== true) {
                        itemTofind = $scope.DeliveryOptions.filter((DelOption) => DelOption.TypeName === 'PrintYourOwn');
                        if (itemTofind.length > 0) {
                            itemToRemoveIndex = $scope.DeliveryOptions.indexOf(itemTofind[0]);
                            ItemsToRemove.push(itemToRemoveIndex);
                        }
                    }
                    if ($scope.params.selectedOutwardTicketDetails.RailJourneyDetail.MobileTicketAvailable !== true
                    || $scope.params.selectedReturnTicketDetails.RailJourneyDetail.MobileTicketAvailable !== true) {
                        itemTofind = $scope.DeliveryOptions.filter((DelOption) => DelOption.TypeName === 'Mobile');
                        if (itemTofind.length > 0) {
                            itemToRemoveIndex = $scope.DeliveryOptions.indexOf(itemTofind[0]);
                            ItemsToRemove.push(itemToRemoveIndex);
                        }
                    }
                } else {
                    //Removing print your own option
                    //Should consider the selected ticket reservation required flag not the journeydetail's reservationRequired flag
                    if ($scope.params.selectedOutwardTicketDetails.RailJourneyDetail.PYOTicketAvailable !== true) {
                        itemTofind = $scope.DeliveryOptions.filter((DelOption) => DelOption.TypeName === 'PrintYourOwn');
                        if (itemTofind.length > 0) {
                            itemToRemoveIndex = $scope.DeliveryOptions.indexOf(itemTofind[0]);
                            ItemsToRemove.push(itemToRemoveIndex);
                        }
                    }
                    if ($scope.params.selectedOutwardTicketDetails.RailJourneyDetail.MobileTicketAvailable !== true) {
                        itemTofind = $scope.DeliveryOptions.filter((DelOption) => DelOption.TypeName === 'Mobile');
                        if (itemTofind.length > 0) {
                            itemToRemoveIndex = $scope.DeliveryOptions.indexOf(itemTofind[0]);
                            ItemsToRemove.push(itemToRemoveIndex);
                        }
                    }
                }

                if (ItemsToRemove.length > 0) {
                    $scope.DeliveryOptions = $scope.DeliveryOptions
                        .filter((value, index) => !ItemsToRemove.includes(index));
                }
            }

            function limitDeliveryOptions() {
                //Checking for the basket items to validate the items already exist in the basket
                //to show the delivery options to the user
                $scope.unavailableDO = false;
                $scope.unavailableDOMsg = '';
                const {POST, NEXTDAY, MOBILE, PRINTYOUROWN} = deliveryOptionTypes;
                const POST_NEXT_DAY_DELIVERY_TYPES = [POST.typeName, NEXTDAY.typeName];
                const ItemsToDisplay = [];
                let itemToAdd;
                const basketRailItems = basketService.getRails();
                angular.forEach(basketRailItems, function(basketRailItem) { // eslint-disable-line
                    if (basketRailItem.TicketDeliveryOptionType === 'Kiosk'
                        || basketRailItem.TicketDeliveryOptionType === 'Collection'
                        || basketRailItem.TicketDeliveryOptionType === 'CorporateKiosk') {
                        if (ItemsToDisplay.filter((objItem) => objItem.TypeName === 'Kiosk').length < 1) {
                            itemToAdd = $scope.DeliveryOptions.filter((objItem) => objItem.TypeName === 'Kiosk');
                            if (itemToAdd.length > 0) {
                                ItemsToDisplay.push(itemToAdd[0]);
                            }
                        }
                        if (ItemsToDisplay.filter((objItem) => objItem.TypeName === 'Collection').length < 1) {
                            itemToAdd = $scope.DeliveryOptions.filter((objItem) => objItem.TypeName === 'Collection');
                            if (itemToAdd.length > 0) {
                                ItemsToDisplay.push(itemToAdd[0]);
                            }
                        }
                        if (ItemsToDisplay.filter((objItem) => objItem.TypeName === 'CorporateKiosk').length < 1) {
                            itemToAdd = $scope.DeliveryOptions.filter((objItem) => objItem.TypeName === 'CorporateKiosk');
                            if (itemToAdd.length > 0) {
                                ItemsToDisplay.push(itemToAdd[0]);
                            }
                        }
                    } else if (ItemsToDisplay.filter((objItem) => objItem.TypeName === basketRailItem.TicketDeliveryOptionType).length < 1) {
                            itemToAdd = $scope.DeliveryOptions.filter((objItem) => objItem.TypeName === basketRailItem.TicketDeliveryOptionType);
                            if (itemToAdd) {
                                if (itemToAdd.length > 0) {
                                    ItemsToDisplay.push(itemToAdd[0]);
                                } else {
                                    $scope.unavailableDO = true;
                                    if (POST_NEXT_DAY_DELIVERY_TYPES.includes(basketRailItem.TicketDeliveryOptionType)) {
                                        $scope.unavailableDOMsg = 'Insufficient time to post tickets before departure. Please create a separate trip for this item.';
                                    } else if (basketRailItem.TicketDeliveryOptionType === MOBILE.typeName) {
                                        $scope.unavailableDOMsg = 'You have selected Mobile for the item in your basket, but is not available for this journey. Please create a separate trip for this item.';
                                    } else if (basketRailItem.TicketDeliveryOptionType === PRINTYOUROWN.typeName) {
                                        $scope.unavailableDOMsg = 'You have selected Print Your Own for the item in your basket, but is not available for this journey. Please create a separate trip for this item.';
                                    }
                                }
                            }
                        }
                });
                if (ItemsToDisplay.length > 0 && !$scope.unavailableDO) {
                    $scope.DeliveryOptions = ItemsToDisplay;
                } else if ($scope.unavailableDO) {
                    $scope.DeliveryOptions = '';
                }
            }

            function getAddressTypes(addressDescription) {
                const emptyAddress = {
                    Id: 0,
                    Description: l10nService.localize('--Select address--'),
                    Address1: '',
                    Address2: '',
                    Address3: '',
                    Address4: '',
                    Address5: '',
                    PostCode: '',
                    HeadOfficeId: '',
                    DepartmentId: '',
                };
                const newAddress = {
                    Id: 0,
                    Description: l10nService.localize('--Add a new address--'),
                    Address1: '',
                    Address2: '',
                    Address3: '',
                    Address4: '',
                    Address5: '',
                    PostCode: '',
                    HeadOfficeId: '',
                    DepartmentId: '',
                };
                railsFactory.getAddressTypes(addressDescription)
                    .then(({data}) => {
                        $scope.AddressTypesList = [emptyAddress, newAddress, ...data];
                        [$scope.params.TicketByPostAddressType] = $scope.AddressTypesList;
                        if (addressDescription) {
                           const ticketByPostAddressType = $scope.AddressTypesList.filter((addr) => addr.Description === addressDescription);
                           if (ticketByPostAddressType) {
                               $scope.params.TicketByPostAddressType = ticketByPostAddressType[0];
                                $scope.params.TicketByPostAddressLines = {};
                                $scope.params.TicketByPostAddressDescription = $scope.params.TicketByPostAddressType.Description;
                                $scope.params.TicketByPostCode = $scope.params.TicketByPostAddressType.PostCode;
                                $scope.params.TicketByPostAddressLines.Line1 = $scope.params.TicketByPostAddressType.Address1;
                                $scope.params.TicketByPostAddressLines.Line2 = $scope.params.TicketByPostAddressType.Address2;
                                $scope.params.TicketByPostAddressLines.Line3 = $scope.params.TicketByPostAddressType.Address3;
                                $scope.params.TicketByPostAddressLines.Line4 = $scope.params.TicketByPostAddressType.Address4;
                                $scope.params.TicketByPostAddressLines.Line5 = $scope.params.TicketByPostAddressType.Address5;
                            }
                        }
                    });
            }

            $scope.disableControls = function() {
                return $scope.params.TicketByPostAddressType.Description !== l10nService.localize('--Add a new address--');
            };

            $scope.changeAddressType = function() {
                if (!$scope.params.TicketByPostAddressType) {
                    return;
                }
                if ($scope.params.TicketByPostAddressType.Id === 0) {
                    $scope.params.TicketByPostAddressDescription = '';
                    $scope.params.TicketByPostAddressLines = [];
                    $scope.params.TicketByPostCode = '';
                } else {
                    $scope.params.TicketByPostAddressLines = {};
                    $scope.params.TicketByPostAddressDescription = $scope.params.TicketByPostAddressType.Description;
                    $scope.params.TicketByPostCode = $scope.params.TicketByPostAddressType.PostCode;
                    $scope.params.TicketByPostAddressLines.Line1 = $scope.params.TicketByPostAddressType.Address1;
                    $scope.params.TicketByPostAddressLines.Line2 = $scope.params.TicketByPostAddressType.Address2;
                    $scope.params.TicketByPostAddressLines.Line3 = $scope.params.TicketByPostAddressType.Address3;
                    $scope.params.TicketByPostAddressLines.Line4 = $scope.params.TicketByPostAddressType.Address4;
                    $scope.params.TicketByPostAddressLines.Line5 = $scope.params.TicketByPostAddressType.Address5;
                }
            };

            $scope.railTooltipTemplate = $sce.trustAsResourceUrl('app/modules/base/templates/ukrail/rail-ticket-tooltip.html');

            $scope.isLowPriceTicket = function({Total}) {
                return railAmendmentService.isAmendmentMode()
                    && (Total < $stateParams.rebook.oldPrice);
            };

            $scope.isTicketTooltipEnabled = function() {
                return $scope.ticketHovered || $scope.lowPriceError;
            };

            $scope.getTicketBreakupAndRestrictions = function(ticket, isCommonPriceTicket) { // eslint-disable-line
                $scope.ticketHovered = null;
                $scope.lowPriceError = false;

                if (railAmendmentService.isAmendmentMode()) {
                    const oldPrice = $stateParams.rebook.oldPrice;
                    const newPrice = ticket.Total;
                    if (newPrice < oldPrice) {
                        $scope.lowPriceError = true;
                        return;
                    }
                }

                if (ticket && ticket.Id !== 0) {
                    if (isCommonPriceTicket) {
                        if (ticket.TicketoutwardJourney.length > 0) {
                            [$scope.ticketHovered] = ticket.TicketoutwardJourney.filter((tkt) => tkt.Id > 0);
                        } else if (ticket.TicketReturnJourney.length > 0) {
                            [$scope.ticketHovered] = ticket.TicketReturnJourney.filter((tkt) => tkt.Id > 0);
                        }
                    } else {
                        $scope.ticketHovered = ticket;
                    }
                    if ($scope.ticketHovered) {
                        $scope.ticketRestrictions = [];
                        $scope.ticketRestrictions.push($scope.ticketHovered.Description);
                        const rteRestriction = $scope.rails.RailRouteRestrictionInformations.filter((rte) => rte.Code === $scope.ticketHovered.RteRestrict);
                        if (rteRestriction) {
                            $scope.ticketRestrictions.push(rteRestriction[0].Description);
                        }
                    }
                }
            };

            $scope.getRailCardName = function(cardCode) {
                [$scope.railCard = {Description: ''}] = $scope.railCards.filter((card) => card.Code === cardCode);
                return $scope.railCard.Description;
            };

            $scope.clearValidationMsg = function() {
                $scope.postAddressDuplicateError = false;
            };
            $scope.saveAddress = function() { // eslint-disable-line
                if ($scope.postCodeErrors && $scope.postCodeErrors.length) {
                    return;
                }
                $scope.postAddressError = false;
                $scope.postAddressDuplicateError = false;

                const {
                    TicketByPostAddressDescription,
                    TicketByPostAddressLines: {
                        Line1,
                        Line2,
                    },
                    TicketByPostCode,
                    TicketByPostName,
                } = $scope.params;

                if (!TicketByPostAddressDescription || !Line1 || !Line2 || !TicketByPostCode) {
                    $scope.postAddressError = true;
                    return;
                }

                if (!TicketByPostName) {
                    $scope.postNameError = true;
                    return;
                }

                const newAddrDescription = TicketByPostAddressDescription;
                const existingAddrObj = $scope.AddressTypesList
                    .filter((obj) => obj.Description.trim().toUpperCase() === newAddrDescription.trim().toUpperCase());
                if (existingAddrObj.length > 0) {
                    $scope.postAddressDuplicateError = true;
                    return;
                }

                const AddressObject = {};
                if ($scope.params.TicketByPostAddressType.Id !== 0) {
                    AddressObject.Id = $scope.params.TicketByPostAddressType.Id;
                } else {
                    AddressObject.Id = 0;
                }
                AddressObject.Description = $scope.params.TicketByPostAddressDescription;
                AddressObject.Address1 = $scope.params.TicketByPostAddressLines.Line1;
                AddressObject.Address2 = $scope.params.TicketByPostAddressLines.Line2;
                AddressObject.Address3 = $scope.params.TicketByPostAddressLines.Line3;
                AddressObject.Address4 = $scope.params.TicketByPostAddressLines.Line4;
                AddressObject.Address5 = $scope.params.TicketByPostAddressLines.Line5;
                AddressObject.PostCode = $scope.params.TicketByPostCode;
                AddressObject.CountryCode = 'Z0';
                railsFactory.saveAddress(AddressObject)
                    .then(() => getAddressTypes(AddressObject.Description));

            };

            $scope.isAddressDescriptionEntered = isAddressDescriptionEntered;
            function isAddressDescriptionEntered() {
                return $scope.postAddressError
                    && !$scope.params.TicketByPostAddressDescription;
            }

            $scope.isPostcodeEntered = isPostcodeEntered;
            function isPostcodeEntered() {
                return $scope.postAddressError
                    && !$scope.params.TicketByPostCode;
            }

            $scope.isAddressLine1Entered = isAddressLine1Entered;
            $scope.isAddressLine2Entered = isAddressLine2Entered;
            function isAddressLine2Entered() {
                const {
                    TicketByPostAddressLines: {
                        Line2,
                    } = {}} = $scope.params;
                return $scope.postAddressError && !Line2;
            }

            function isAddressLine1Entered() {
                const {
                    TicketByPostAddressLines: {Line1} = {},
                } = $scope.params;
                return $scope.postAddressError && !Line1;
            }

            $scope.getOutOfPolicyStatusStyle = getOutOfPolicyStatusStyle;
            function getOutOfPolicyStatusStyle(status) {
                return outOfPolicyStatusStyle(status);
            }

            $scope.getOutOfPolicyToolTipMessageStyle = function(status) {
                if (status === 1 || status === 2) {
                    return 'policy-warn';
                } else if (status === 3 || status === 4 || status === 5) {
                    return 'policy-error';
                }
                    return '';
            };

            angular.element('.matrix-ticket-hover').hover(function() {
                angular.element(this).parent().children(':first-child').addClass('matrix-header-hover');
            },
                function() {
                    angular.element(this).parent().children(':first-child').removeClass('matrix-header-hover');
                });

            angular.element('.cellhighlight').hover(function() {
                angular.element(this).parent().children(':first-child').addClass('cellhighlight');
            },
                function() {
                    angular.element(this).parent().children(':first-child').removeClass('cellhighlight');
                });

            angular.element(document).on('click', '.matrix-radio-onwards', function() {
                angular.element('.matrix-ticket, .col-sm-2').removeClass('matrix-radio-onwards-click');
                angular.element(this).closest('.matrix-ticket').addClass('matrix-radio-onwards-click');
                angular.element(this).parents('.col-sm-5').siblings('.col-sm-2').addClass('matrix-radio-onwards-click');
            });

            angular.element(document).on('click', '.matrix-radio-return', function() {
                angular.element('.matrix-ticket, .col-sm-2').removeClass('matrix-radio-return-click');
                angular.element(this).closest('.matrix-ticket').addClass('matrix-radio-return-click');
                angular.element(this).parents('.col-sm-5').siblings('.col-sm-2').addClass('matrix-radio-return-click');
            });


            angular.element('.row').on('mouseenter mouseleave', '.matrix-ticket-hover', function(evt) {
                if (evt.type === 'mouseenter') {
                    angular.element(this).parent().children('div:first-child').addClass('matrix-header-hover');
                    } else {
                    angular.element(this).parent().children('div:first-child').removeClass('matrix-header-hover');
                }
            });

            angular.element('.row').on('mouseenter mouseleave', '.cellhighlight', function(evt) {
                if (evt.type === 'mouseenter') {
                    angular.element(this).parent().children('div:first-child').addClass('cellhighlight');
                    } else {
                    angular.element(this).parent().children('div:first-child').removeClass('cellhighlight');
                }
            });

            angular.element(document).on('click', '.calling-points', function() {
                angular.element('[data-toggle="popover"]').popover();
            });
}



// WEBPACK FOOTER //
// ./src/app/modules/base/controllers/ukrail/ukrailResultBaseCtrl.js